import { useState } from 'react';

import { useMediaQuery } from '@material-ui/core';

import BarCodeIcon from 'images/icons/barCodes/barCodeDarkGrayOutline.svg';
import BarCodeActiveIcon from 'images/icons/barCodes/barCodeWhiteOutline.svg';

import { ValidityFilterBox } from '../../../products/styles';

function ValitidyFilterLabels({
  onClick,
  initialActive = [],
  validityFilterInfos,
  filterOpen,
}) {
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const isMobileScreen = useMediaQuery('(max-width: 866px)');

  const expiredInfos = validityFilterInfos?.content?.find(
    (f) => f?.labelStatus === 'EXPIRED'
  );
  const validInfos = validityFilterInfos?.content?.find(
    (f) => f?.labelStatus === 'VALID'
  );

  const [activeFilters, setActiveFilters] = useState(initialActive || []);

  const FILTERS = [
    {
      label: 'VENCIDAS',
      key: 'EXPIRED',
      colorClass: 'expired', 
      total: expiredInfos?.total || 0,
    },
    {
      label: 'À VENCER',
      key: 'VALID',
      colorClass: 'valid', 
      total: validInfos?.total || 0,
    },
  ];

  const buildTotalValueText = (filter) => {
    let text = `${filter.label}: ${filter?.total}`;
    if (isMobileScreen) text = `QTDE: ${filter?.total}`;
    if (isPhoneScreen) text = filter?.total;
    return text;
  };

  const handleToggle = (key) => {
    const isActive = activeFilters.includes(key);
    const newFilters = isActive
      ? activeFilters.filter((f) => f !== key)
      : [...activeFilters, key];

    setActiveFilters(newFilters);
    onClick?.(newFilters);
  };

  return (
    <ValidityFilterBox filterOpen={filterOpen} alignRight>
      {FILTERS.map((filter) => {
        const isActive = activeFilters.includes(filter.key);
        return (
          <div
            key={filter.key}
            className={`validityCard ${filter.colorClass} ${isActive ? 'active' : ''}`}
            onClick={() => handleToggle(filter.key)}
          >
            <p className="title">
              {isMobileScreen ? filter.label : 'ETIQUETAS'}
            </p>

            <div className="labelAndValue">
              {buildTotalValueText(filter)}
              <img
                style={{ width: '20px' }}
                src={isActive ? BarCodeActiveIcon : BarCodeIcon}
                alt="BarCodeIcon"
              />
            </div>
          </div>
        );
      })}
    </ValidityFilterBox>
  );
}

export default ValitidyFilterLabels;
